export default "__VITE_ASSET__DnnArfJo__"